import AccessTimeOutlined from '@mui/icons-material/AccessTimeOutlined';
import CancelOutlined from '@mui/icons-material/CancelOutlined';
import CheckCircleOutlined from '@mui/icons-material/CheckCircleOutlined';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import StatsCard from '../StatsCard';
import {
    DateStackSx,
    DateTextSx,
    ErrorIconSx,
    IconSx,
    InvalidDateTextSx,
    ProcessingIconSx,
    ProcessingTextSx
} from './styles';
import { LastSyncCardProps } from './types';
import { formatDate, isValidDate } from './utils';

const LastSyncCard = (props: LastSyncCardProps) => {
  const { 'data-testid': dataTestId, lastSyncDate, processing } = props;
  
  const formattedDate = formatDate(lastSyncDate);
  const isValid = isValidDate(lastSyncDate);
  
  let cardContent;
  
  if (processing) {
    cardContent = (
      <Stack sx={DateStackSx}>
        <AccessTimeOutlined sx={ProcessingIconSx} />
        <Typography sx={ProcessingTextSx}>Syncing...</Typography>
      </Stack>
    );
  } else if (!isValid) {
    cardContent = (
      <Stack sx={DateStackSx}>
        <CancelOutlined sx={ErrorIconSx} />
        <Typography sx={InvalidDateTextSx}>N/A</Typography>
      </Stack>
    );
  } else {
    cardContent = (
      <Stack sx={DateStackSx}>
        <CheckCircleOutlined sx={IconSx} />
        <Typography sx={DateTextSx}>{formattedDate}</Typography>
      </Stack>
    );
  }

  return (
    <StatsCard
      data-testid={dataTestId}
      title="Date"
      value={cardContent}
    />
  );
};

export default LastSyncCard; 
